import CoreLayout from '../layouts/PageLayout/PageLayout'
import RequireAuth from '../components/Auth/RequireAuth'

import Login from './Login'
import PatientMonitoring from './PatientMonitoring'
import mPatientMonitoring from './MPatientMonitoring'
import NotFoundPage from './NotFoundPage'
import ChangePassword from './ChangePassword'
import SystemSetting from './SystemSetting'
//import SystemAdmin from './SystemAdmin'
import BedSetting from './BedSetting'
import PatientManagement from './PatientManagement'
import VideoWall from './VideoWall'


export const createRoutes = (store) => ({
  path        : '/',
  component   : CoreLayout,
  childRoutes : [
    {
      component: RequireAuth(CoreLayout),
      indexRoute: PatientMonitoring(store),
      childRoutes: [
        PatientMonitoring(store),
        mPatientMonitoring(store),
        SystemSetting(store),
        BedSetting(store),
        PatientManagement(store),
        //SystemAdmin(store),
        VideoWall(store),
        ChangePassword,
      ]
    },
    {
      component: CoreLayout,
      childRoutes: [
        Login,
      ]
    },
    {
      path: '*',
      component: CoreLayout,
      indexRoute: NotFoundPage
    }
  ]
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js